//Report Page 1st - Campaign and template details//
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const UnSubsribedList = () => {
  const [userList, setUsersList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const navigate = useNavigate();
  const BUId = sessionStorage.getItem('BUId');



  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userResponse = await fetch(`${process.env.REACT_APP_API_URL}/Report/UnSubscribedListReport?BUId=${BUId}`);

        if (!userResponse.ok) {
          throw new Error('Failed to fetch data');
        }  

        const data = await userResponse.json();
        console.log(data)
        setUsersList(data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchUserData();
  }, [BUId]);

  // Filter users based on search query
  const filteredUserList = userList.filter(user =>
    user.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.emailAddress.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredUserList.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const totalPages = Math.ceil(filteredUserList.length / itemsPerPage);

//   const handleViewClick = (campaignId, templateId) => {
//     navigate(`/AudienceList?campaignId=${campaignId}&templateId=${templateId}`);
//   };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="container mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
        {/* Header */}
        <div className="bg-gray-200 p-4">
          <h1 className="text-xl">UnSubscribed List Report</h1>
        </div>

        {/* Search Input */}
        <div className="p-4 bg-gray-100 border-b">
          <div className="max-w-md ml-auto relative">
            <input
              type="text"
              placeholder="Search emails, names..."
              className="w-full p-3 pl-10 text-gray-700 bg-white rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1); // Reset to first page when searching
              }}
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 absolute left-3 top-3 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div>

        {/* Table */}
        <div className="w-full overflow-x-auto bg-white rounded-lg shadow">
          <table className="w-full">
            <thead>
              <tr className="bg-gradient-to-r from-blue-500 to-purple-600">
                <th className="px-6 py-3 text-left text-sm font-semibold text-white">First Name</th>
                <th className="px-6 py-3 text-left text-sm font-semibold text-white">Email Address</th>
                {/* <th className="px-6 py-3 text-left text-sm font-semibold text-white">Total Mails Sent</th>
                <th className="px-6 py-3 text-left text-sm font-semibold text-white">Total Mails Scheduled</th>
                <th className="px-6 py-3 text-left text-sm font-semibold text-white">Total Contacts Imported</th>
                <th className="px-6 py-3 text-left text-sm font-semibold text-white">Total Open Count</th>
                <th className="px-6 py-3 text-left text-sm font-semibold text-white">Total Click Count</th>
                <th className="px-6 py-3 text-left text-sm font-semibold text-white">View</th> */}
                {/* <th className="px-6 py-3 text-left text-sm font-semibold text-gray-600 hidden">Campaign Id</th> 
                <th className="px-6 py-3 text-left text-sm font-semibold text-gray-600 hidden">Template Id</th>  */}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {filteredUserList.length > 0 ? (
                currentItems.map((user, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-6 py-4 text-sm text-gray-900">{user.firstName || ''}</td>
                    <td className="px-6 py-4 text-sm text-gray-900">{user.emailAddress}</td>
                    {/* <td className="px-6 py-4 text-sm text-gray-900">{user.totalMailSentCount}</td>
                    <td className="px-6 py-4 text-sm text-gray-900">{user.totalMailScheduled}</td>   
                    <td className="px-6 py-4 text-sm text-gray-900">{user.totalMailUnScheduled}</td> 
                    <td className="px-6 py-4 text-sm text-gray-900">{user.totalMailOpenCount}</td> 
                    <td className="px-6 py-4 text-sm text-gray-900">{user.totalButtonCount}</td>  */}
                    {/* <td className="px-6 py-4">
                     
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-blue-500 cursor-pointer"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        onClick={() => handleViewClick(user.campaignId, user.templateId)}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 12m0 0h.01M12 15l3-3-3-3"
                        />
                      </svg>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-900 hidden">{user.campaignId}</td> 
                    <td className="px-6 py-4 text-sm text-gray-900 hidden">{user.templateId}</td>  */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="px-6 py-4 text-sm text-center text-gray-600">No Details found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="bg-gray-100 px-4 py-3 flex items-center justify-center space-x-2">
            <button
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Previous
            </button>

            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index}
                onClick={() => paginate(index + 1)}
                className={`px-4 py-2 text-sm font-medium rounded-lg border 
                  ${currentPage === index + 1
                    ? 'bg-blue-500 text-white border-blue-500'
                    : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                  }`}
              >
                {index + 1}
              </button>
            ))}

            <button
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default UnSubsribedList;
